<template>
  <div
    class="fixed z-30 bottom-0 left-0 right-0 bg-white h-28 border-t-1 border-gray-lighter flex justify-center items-center px-6 lg:hidden"
  >
    <OButton
      variant="primary"
      class="max-w-screen-sm flex-1"
      @click="$emit('click')"
    >
      <slot></slot>
    </OButton>
  </div>
</template>

<script>
export default {}
</script>
